export default "__VITE_ASSET__Dq6c1BUK__"